export default __webpack_public_path__ + "static/media/JOSA SYLLABUS_2026-27 CLASS 7.cdea9b0f.pdf";